import { SelectV2 } from "@/modules/common/components";

import { FilterFieldRendererProps } from "../types";

const SelectAsyncFilterField = ({ field, value, onChange }: FilterFieldRendererProps) => {
  const { options, isLoading, hasMore, onLoadMore, onSearch } = field.useOptions?.() ?? { options: [] };

  return (
    <SelectV2
      mode="single"
      align="start"
      placeholder={field.label}
      options={options}
      isLoading={isLoading}
      hasMore={hasMore}
      onLoadMore={onLoadMore}
      onSearch={onSearch}
      value={value !== undefined ? String(value) : undefined}
      onChange={(next) => {
        if (next === undefined) {
          onChange(undefined);
          return;
        }
        const parsed = field.schema.safeParse(next);
        onChange(parsed.success ? parsed.data : undefined);
      }}
    />
  );
};

export default SelectAsyncFilterField;
